var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container appstore_wrap"},[_c('store-header',{attrs:{"tabs":"index","showDoc":true,"defaultMarket":_vm.defaultMarketDomain}}),_vm._v(" "),_c('IndexHeader'),_vm._v(" "),(_vm.steps === 'index')?_c('IntroduceRainstore'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284bc3d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../cache/node/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/Index.vue
// module id = null
// module chunks = 